import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import { useEmbeddedAuth } from '../../contexts/EmbeddedAuthContext';
import { getToken } from '../../services/authService';

const ExploreSection = ({ 
  title, 
  icon, 
  link, 
  children, 
  className = "",
  headerClassName = ""
}) => {
  const navigate = useNavigate();
  const { showLoginModal } = useEmbeddedAuth();

  const handleLinkClick = (e) => {
    e.preventDefault();
    // 允许未登录用户访问
    navigate(link);
  };

  return (
    <div className={`flex flex-col w-full max-w-[856px] mx-auto min-w-0 ${className}`}>
      <div className={`flex items-center justify-between mb-4 ${headerClassName}`}>
        <div className="flex items-center gap-2">
          {icon && <span className="text-xl flex items-center">{icon}</span>}
          <h2 
            className="text-[20px] font-bold text-white leading-normal"
            style={{ fontFamily: 'OPPOSans, sans-serif' }}
          >
            {title}
          </h2>
        </div>
        
        {link && (
          <a 
            href={link}
            onClick={handleLinkClick}
            className="text-[14px] font-medium text-white hover:text-[#F0FF31] leading-normal flex items-center gap-1 transition-colors cursor-pointer"
            style={{ fontFamily: 'OPPOSans, sans-serif' }}
          >
            查看更多 <RightOutlined />
          </a>
        )}
      </div>
      
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};

export default ExploreSection;
